import { Helmet } from "react-helmet-async";

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonical,
  type = "website"
}) => {
  const siteName = "Hammer Sports Logic";
  const defaultDescription = "Free expert sports picks with a verified track record. Join the Road to $100K with data-driven analysis. Logic over luck.";
  const siteUrl = "https://hsl.bets";
  
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} | Expert Sports Picks & Analysis`;
  const metaDescription = description || defaultDescription;
  const canonicalUrl = canonical ? `${siteUrl}${canonical}` : siteUrl;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content={siteName} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
    </Helmet>
  );
};

export default SEO;
